import ChooseTable from './ChooseTable.vue';

export default ChooseTable;
